import { render, staticRenderFns } from "./DeleteModalIcon.vue?vue&type=template&id=2f9e02a6&scoped=true"
import script from "./DeleteModalIcon.vue?vue&type=script&lang=js"
export * from "./DeleteModalIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9e02a6",
  null
  
)

export default component.exports